export default "__VITE_ASSET__BcwsghaV__"